import axios from "axios";
import { IApplication } from "../models/application.model";
import ResourceFactory from "./resource";

export const ACTION_TYPES = {
  UPLOAD_FILE: "applications/UPLOAD_FILE",
  CONVERT_PROPOSAL: "applications/CONVERT_PROPOSAL",
};

const resourceKey = "applications";
const resourceUrl = "applications";
const resourceIdKey = "id";

const { reducer, fetchList, create, fetch, update, hideErrorToast, remove } = ResourceFactory<IApplication>(
  resourceKey,
  resourceUrl,
  resourceIdKey,
);

export type ApplicationResourcesState = ReturnType<typeof reducer>;
export const fetchApplicationsList = fetchList;
export const createApplication = create;
export const fetchApplication = fetch;
export const updateApplication = update;
export const removeApplication = remove;
export const hideErrorToastApplication = hideErrorToast;

export default reducer;

export const uploadAplication = (carrierTypeId: string, branchTypeId: string, statusTypeId: string, file: any) => {
  const formData = new FormData();
  formData.append("pdfFile", file);
  return {
    type: ACTION_TYPES.UPLOAD_FILE,
    payload: axios.post(
      `/applications/uploadApp?carrierTypeId=${carrierTypeId}&branchTypeId=${branchTypeId}&statusTypeId=${statusTypeId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    ),
  };
};

export const convertFromProposal = (
  proposalID,
  carrierTypeID = "",
  occupationClassTypeID = "",
  designTypeID = "",
  productName = "",
  fileIdList = [],
) => {
  return {
    type: ACTION_TYPES.CONVERT_PROPOSAL,
    payload: axios.post(
      `/applications/convertProposalToApp?proposalID=${proposalID}&carrierTypeId=${carrierTypeID}&occClassTypeID=${occupationClassTypeID}&productTypeID=${designTypeID}&productName=${productName}`,
      fileIdList,
    ),
  };
};
